import React from "react";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { Description } from "./styles";
export const DescriptionDisplay = () => {
  var _newsletterItemForDis;
  const {
    newsletterItemForDisplay
  } = useNewsletterContext();
  return /*#__PURE__*/React.createElement(Description, {
    "data-qa": "description-display"
  }, newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 || (_newsletterItemForDis = newsletterItemForDisplay.homepageDescription) === null || _newsletterItemForDis === void 0 ? void 0 : _newsletterItemForDis.text);
};
DescriptionDisplay.displayName = "DescriptionDisplay";